import React from 'react';
import PageMeta from '../components/PageMeta';
import FAQAccordion from '../components/FAQAccordion';
import Reveal from '../components/Reveal';
import { faqs } from '../data/siteData';
import { FinalCTA, PageHero } from '../components/SharedSections';

function FAQ() {
  const schema = { '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: faqs.map((faq) => ({ '@type': 'Question', name: faq.question, acceptedAnswer: { '@type': 'Answer', text: faq.answer } })) };

  return (
    <>
      <PageMeta title="Frequently Asked Questions" description="Answers about vendor-neutral technology advice, pricing, UCaaS, service areas, and switching providers." schema={schema} />
      <PageHero eyebrow="Frequently asked questions" title="Straight answers before you make a technology decision." text="Understand how independent guidance works, what it costs, and what to expect from an assessment or provider change." />
      <section className="section narrow">
        <Reveal><FAQAccordion items={faqs} /></Reveal>
      </section>
      <FinalCTA />
    </>
  );
}

export default FAQ;